export const ORDER_FIELD_STREET_ID = 9;
export const ORDER_FIELD_NUMBER_ID = 10;
export const ORDER_FIELD_COMPLEMENT_ID = 11;
export const ORDER_FIELD_DISTRICT_ID = 12;
export const ORDER_FIELD_CITY_ID = 22;
export const ORDER_FIELD_ZIP_CODE_ID = 21;
export const ORDER_FIELD_LATITUDE = 31;
export const ORDER_FIELD_LONGITUDE = 32;
